module.exports = __webpack_public_path__ + "img/telegram_channel-monochrome.8fea6867.svg";